/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { ILeagueModel, ImageHelper } from "@bms/common";
import React from "react";

import "./LeagueTableHeader.scss";

interface ILeagueTableHeaderProps {
  league: ILeagueModel;
}

export const LeagueTableHeader = ({ league }: ILeagueTableHeaderProps) => {
  const leagueLogo =
    ImageHelper.getRoundImage(league.Images) ??
    ImageHelper.getSquareImage(league.Images);

  return (
    <div className="LeagueTableTab__header">
      {leagueLogo && (
        <img
          src={leagueLogo.Url}
          alt={league.Name}
          className="LeagueTableTab__header-logo"
        />
      )}
      <div className="LeagueTableTab__header-info">
        {league.Name && (
          <span className="LeagueTableTab__header-name">{league.Name}</span>
        )}
        {(league.CountryName || league.CountryFlag) && (
          <span className="LeagueTableTab__header-country">
            {league.CountryFlag && (
              <img
                src={league.CountryFlag}
                alt={league.CountryName}
                className="LeagueTableTab__header-country-flag"
              />
            )}
            {league.CountryName}
          </span>
        )}
        {league.SeasonDisplayName && (
          <span className="LeagueTableTab__header-season">
            {league.SeasonDisplayName}
          </span>
        )}
      </div>
    </div>
  );
};
